import React                        from 'react';
import { DateRange, TimeSpan, UTC } from 'rewire-common';
import { observable, Observe }      from 'rewire-core';
import classNames                   from 'classnames';
import TextField                    from '@material-ui/core/TextField';
import SearchIcon                   from '@material-ui/icons/SearchOutlined';
import Autocomplete                 from '@material-ui/lab/Autocomplete';
import Queries                      from '../graphql/Queries';
import { nameSearcher }             from '../utility/Searchers';
import { makeStyles, Theme }        from '../utility/styles';
import { RouteManagerBase }         from './RouteManager';

function performScheduleSearch(search: string) {
  return Queries.scheduleSearch(
`earnedDate
employee { id name }
reason { id name }
overtimeReason { id name }
occupation { id name }
group { id name }
template { id name }
generator { id name }
`, search, RouteManagerBase.current?.effective ?? new DateRange(UTC.now().startOfDay(), UTC.now().add(6, TimeSpan.days).startOfDay()), 25
  );
}

const searcher = nameSearcher(performScheduleSearch);

const model = observable({
  async search(text: string) {
    const items = await searcher.search(text) as any[];
    model.items.set(items);
    model.text = text;
  },
  text: '',
  value: {name: ''} as any,
  items: [] as any[],
  open: false
});

const styles = (_theme: Theme) => ({
  popper: {
    width: '1100px !important',
    maxWidth: '100vh',
    maxHeight: '80vh',
    height: '100%',
    right: 0,
    top: 38,
  },
  listbox: {
    display: 'grid',
    padding: 20,
    fontSize: '12px',
    gridTemplateColumns: 'repeat(8, minmax(75px, auto))',
    gridRowGap: 4,
    maxHeight: '80vh'
  },
  heading: {
    fontWeight: 'bold',
    color: '#fff',
    backgroundColor: '#14809d',
    fontSize: '14px',
    padding: 4,
  },
  option: {
    display: 'contents',
  },
  item: {
    padding: 4,
    '&.selected': {
      backgroundColor: '#eee'
    }
  }
});
const useStyles = makeStyles(styles);

const ListboxComponent = ({children, ...other}: any) => {
  const s = useStyles();
  return <ul {...other}>
    <>
    <div className={s.heading}>Earned Date</div>
    <div className={s.heading}>Employee</div>
    <div className={s.heading}>Group</div>
    <div className={s.heading}>Occupation</div>
    <div className={s.heading}>Shift Type</div>
    <div className={s.heading}>Shift Pattern</div>
    <div className={s.heading}>Reason</div>
    <div className={s.heading}>OT Reason</div>
    {children}
    </>
  </ul>;
};

function handleKeyDown(evt: React.KeyboardEvent<HTMLDivElement>) {
  if (evt.key === 'Enter') {
    const search = model.text;
    model.open   = false;
    if (search) {
      RouteManagerBase.current.navigateTo({filters: {search}});
      // payRouteManager.navigateTo({filters: {search}});
      // timecardModel.routeManager.navigateTo({filters: {search}});
    }
  }
}

export default function ScheduleSearch() {
  const s = useStyles();
  return <Observe render={() => (
    <Autocomplete
      style={{ width: 250 }}
      open={model.open}
      size='small'
      fullWidth={true}
      classes={{popper: s.popper, listbox: s.listbox, option: s.option}}
      onOpen={() => model.open = true}
      onClose={() => {
        model.open = false;
      }}
      disablePortal
      filterOptions={(options, _state) => options}
      getOptionDisabled={() => true}
      clearOnBlur={false}
      onKeyDown={(evt) => handleKeyDown(evt)}
      options={model.items.map(i => i)}
      ListboxComponent={ListboxComponent}
      renderOption={(option, { selected }) => {
        return (
          <>
            <div className={classNames(s.item, {selected})}>{option.earnedDate.toDateString() ?? ''}</div>
            <div className={classNames(s.item, {selected})}>{option.employee?.name            ?? ''}</div>
            <div className={classNames(s.item, {selected})}>{option.group?.name               ?? ''}</div>
            <div className={classNames(s.item, {selected})}>{option.occupation?.name          ?? ''}</div>
            <div className={classNames(s.item, {selected})}>{option.template?.name            ?? ''}</div>
            <div className={classNames(s.item, {selected})}>{option.generator?.name           ?? ''}</div>
            <div className={classNames(s.item, {selected})}>{option.reason?.name              ?? ''}</div>
            <div className={classNames(s.item, {selected})}>{option.overtimeReason?.name      ?? ''}</div>
          </>
        );}
      }
      renderInput={(params) => (
        <Observe render={() => {
          return (
            <TextField {...params} value={model.text} variant="standard" placeholder="search" onChange={(evt: React.ChangeEvent<HTMLInputElement>) => model.search(evt.target.value)} InputProps={{...params.InputProps, startAdornment: (<SearchIcon />)}}
            />
          );
        }}/>
      )}
    />)
  } />;
}
